import type { QueryClient } from "@tanstack/react-query";
import { AdvisorKeys } from "web_myplann/Api/Advisor/AdvisorKeys";

export const invalidateAssignedAgents = (queryClient: QueryClient) =>
	queryClient.invalidateQueries({ queryKey: AdvisorKeys.assignedAgentsRoot() });
